<template>
	<div style="background-color: #fdfdfd;">
		<Header :isHome="false"></Header>
		
		<div class="top-bg" style="padding-top: 3rem;">
			<div class="title-box">
				<img src="../../assets/imgs/export-title-icon.png" class="title-icon">
				<span class="title-text">Discussion</span>
			</div>
			<div style="" class="search-box" @keydown.enter="tosearchmain(3)">
				<input type="text" style="border: none;background-color: transparent;color: #000;font-size: 1rem;width: 100%;" v-model="searchkeyword" placeholder="Search">
				<img src="../../assets/imgs/search-dark.png" style="width: 1rem;height: 1rem;cursor: pointer;" @click="tosearchmain(3)">
			</div>
		</div>
		<div class="container" v-if="circledata&&hotdata">
			<div class="row" style="margin-top: 1rem;margin-bottom: 3rem;">
				<div class="col-9 main-box">
					<div class="r-title">
						<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
						<span style="z-index: 1;position: relative;">Circle List</span>
					</div>
					<div style="display: flex;flex-direction: column;">
						<div style="display: flex;flex-direction: column;padding: 2rem;border-radius: 0.5rem;margin-bottom: 2rem;cursor: pointer;" v-for="(item, index) in circledata" :key="index"
								class="circle-box hover-up transition-normal" @click="tocircletopic(item.id)">
							<div style="display: flex;align-items: center;">
								<div style="flex: 1;display: flex;align-items: center;">
									<div class="avatar" :style="{backgroundImage:'url('+item.avatar+')'}" style="min-width: 3rem;height: 3rem;margin-right: 1rem;"></div>
									<div style="display: flex;flex-direction: column;">
										<div style="font-weight: bold;font-size: 1.2rem;">{{item.title}}</div>
										<!-- <div style="display: flex;flex-wrap: wrap;">
											<span v-for="(tag, tindex) in item.tagNames.split(',')" :style="{color:colorlist[tindex]}" style="margin-right: 0.5rem;font-size: 0.7rem;">#{{tag}}</span>
										</div> -->
									</div>
								</div>
								<div style="display: flex;align-items: center;" v-if="!isMobile">
									<img src="../../assets/imgs/dis-right-icon.svg" style="width: 1rem;height: 1rem;margin-right: 0.5rem;">
									<div style="margin-right: 2rem;">{{item.followCount}}</div>
									<div style="display: flex;">
										<div :style="{backgroundImage:'url('+avatar+')'}" v-for="(avatar, avatarindex) in item.avatars.slice(0,7)" :key="avatarindex"
												style="width: 1.8rem;height: 1.8rem;border-radius: 50%;margin-left: -0.5rem;background-repeat: no-repeat;background-size: cover;background-position: center;
														border: 1px solid #fff;"></div>
									</div>
								</div>
							</div>
							<div style="font-size: 0.9rem;color: #333;margin: 1rem 0;">
								{{item.profile}}
							</div>
							<div style="display: flex;align-items: center;justify-content: flex-end;" v-if="isMobile">
								<img src="../../assets/imgs/dis-right-icon.svg" style="width: 1rem;height: 1rem;margin-right: 0.5rem;">
								<div style="margin-right: 2rem;">{{item.followCount}}</div>
								<div style="display: flex;">
									<div :style="{backgroundImage:'url('+avatar+')'}" v-for="(avatar, avatarindex) in item.avatars.slice(0,3)" :key="avatarindex"
											style="width: 1.8rem;height: 1.8rem;border-radius: 50%;margin-left: -0.5rem;background-repeat: no-repeat;background-size: cover;background-position: center;
													border: 1px solid #fff;"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="col-3 r-box">
					<div class="r-title">
						<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
						<span style="z-index: 1;position: relative;">My Dyanmic</span>
					</div>
						<div style="border: 1px solid #eee;display: flex;height: 4.5rem;width: 100%;border-radius: 0.5rem;">
							<div style="border-right: 1px solid #eee;display: flex;flex-direction: column;align-items: center;justify-content: center;width: 50%;">
								<span style="color: #000;font-size: 1.7rem;font-weight: bold;line-height: 1;">{{user?user.joinCircleCount:0}}</span>
								<span style="font-size: 0.8rem;font-weight: bold;">Join Topics</span>
							</div>
							<div style="border-right: 1px solid #eee;display: flex;flex-direction: column;align-items: center;justify-content: center;width: 50%;">
								<span style="color: #000;font-size: 1.7rem;font-weight: bold;line-height: 1;">{{user?user.topicCount:0}}</span>
								<span style="font-size: 0.8rem;font-weight: bold;">Dynamic</span>
							</div>
						</div>
						<div class="r-title" style="margin-top: 3rem;">
							<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
							<span style="z-index: 1;position: relative;">Hot dynamic</span>
						</div>
					
					
					<div class="r-content">
					<div style="display: flex;flex-direction: column;" class="hotcomment">
										<vue-seamless-scroll :data="hotdata"  :class-option="optionHover">
						<div style="display: flex;flex-direction: column;border-radius: 0.5rem;margin-top: 1rem;border-bottom: 1px solid #eee;" v-for="(item, hindex) in hotdata" :key="hindex"
								class="r-content">
							<div style="display: flex;align-items: center;">
								<div style="flex: 1;display: flex;align-items: center;">
									<div class="avatar" :style="{backgroundImage:'url('+item.user.avatar+')'}" style="min-width: 3rem;height: 3rem;margin-right: 1rem;"></div>
									<div style="display: flex;flex-direction: column;">
										<div style="font-weight: bold;font-size: 1rem;">{{item.user.username}}</div>
										<div style="display: flex;flex-wrap: wrap;">
											<span v-for="(tag, htindex) in item.user.tags" :style="{color:colorlist[htindex]}" style="margin-right: 0.5rem;font-size: 0.7rem;">#{{tag.name}}</span>
										</div>
									</div>
								</div>
							</div>
							<div style="font-size: 0.7rem;margin: 1rem 0;" class="hover-color">
								{{item.content}}
							</div>
						</div>
										</vue-seamless-scroll>
					</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
			import Header from '/src/components/header.vue'
			import Footer from '/src/components/footer.vue'
			export default {
				data() {
					return {
						circledata:null,
						page:1,
						perPage:20,
						colorlist:['#01A587', '#8D66F8', '#ED532B', '#D8BE50', '#52A5F7'],
						
						hotdata:[],
						
						islogin:false,
						headers:{},
						user:null,
						searchkeyword: '',
						isMobile:false
					}
				},
				props:{
				},
				components: {
					Header,
					Footer
				},
				computed: {
					optionHover() {
						return {
							step: 0.3, // 数值越大速度滚动越快
							limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
							hoverStop: true, // 是否开启鼠标悬停stop
							direction: 1, // 0向下 1向上 2向左 3向右
							openWatch: true, // 开启数据实时监控刷新dom
							singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
							singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
							waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
						};
					},
				  
				},
				filters: {
				},
				methods: {
					tosearchmain(type){
						this.$router.push({name:'searchmain', query:{type:type,keyword:this.searchkeyword}})
					},
					tocircletopic(id){
						this.$router.push({name:'circletopic',query:{id:id}})
					},
					getuserinfo(){
						if(this.islogin){
							this.request({
								method: 'get',
								url: '/gci/user/info',
							}).then(res => {
								this.user = res.data
							}).catch(error => {
								console.error(error.response)
							})
						}
					},
					gethotdata(){
							this.request({
								method: 'get',
								url: '/gci/circleTopic/list?isHot=true&perPage=6&page=1',
							}).then(res => {
								this.hotdata = res.data.items
							}).catch(error => {
								console.error(error.response)
							})
					},
					getcricledata(){
						this.request({
							method: 'get',
							url: '/gci/circle/list',
						}).then(res => {
							this.circledata = res.data.items
							this.$bus.$emit('loading', false)
						}).catch(error => {
							console.error(error.response)
						})
					},
				},
				created() {
					this.$bus.$emit('loading', true)
				},
				mounted() {
					localStorage.getItem('isMobile')=='null'?this.isMobile=false:this.isMobile=true
					let token = localStorage.getItem('token')
					if(token){
						this.islogin = true
						this.headers = {authorization:localStorage.getItem('token')}
					}
					this.getcricledata()
					this.gethotdata()
					this.getuserinfo()
				}
			}
</script>

<style scoped lang="scss">
	.hover-color{color:#333}
	.hover-color-box:hover{
		.hover-color{
			text-decoration: underline;
			color: #00E8BE;
		}
	}
	.avatar{
		background-position: center;background-repeat: no-repeat;background-size: cover;border-radius: 50%;
	}
	.r-title{
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		position: relative;
		.r-title-bg{
			width: 13rem;position: absolute;left: -0.5rem;top: -2rem
		}
	}
	.main-box{
		display: flex;flex-direction: column;padding-left: 3rem;
	}
	.title-text{
		margin-left:-2rem
	}
	.title-box{
		display:flex;align-items: center;justify-content: center;font-weight: 900;color: #fff;font-size: 3rem;
	}
	.title-icon{
		width: 3rem;height: 3rem;margin-top: 0.5rem;
	}
	.top-bg{
		width: 100vw;height: 20rem;display: flex;align-items: center;justify-content: center;
		background-image: url('../../assets/imgs/circle-top.jpg');background-size: cover;background-position: center top;background-repeat: no-repeat;
		flex-direction: column;
	}
	.search-box{
		width: 30rem;height: 3rem;background-color: #fff;margin-top: 1rem;border-radius: 5rem;padding: 0 1rem;
		display: flex;align-items: center;
	}
	.circle-box{
		box-shadow:0 10px 10px rgba(0, 0, 0, 0.08)
	}
	.circle-box:hover{
		box-shadow:  0 4px 60px 0 rgba(0,0,0,0.2);
	}
	.hotcomment{
		max-height: 52rem;
		overflow: hidden;
	}
	.hotcomment::-webkit-scrollbar{display: none;}
	@media (max-width:767px) {
		.row{
			flex-direction: column;
		}
		.main-box{
			max-width: 100%;padding-left: 1rem;margin-top: 2rem;
		}
		.r-box{
			max-width: 100%;
		}
		.title-box{
			font-size: 2rem;
		}
		.search-box{
			width: 17rem;
		}
		.title-icon{
			// margin-top: -2rem;
		}
		.r-content{
			padding:0 1rem
		}
	}
</style>